module.exports = __webpack_public_path__ + "static/mongoDB-b72f8ca2755e71a3278dff75888bb359.png";